import React from 'react';
import { LegalRef, CatalogEdit } from './LegalRef';

export const OrganoCard = ({ o, admin, onChange }) => (
  <div data-testid={`organo-${o.id}`} className="rounded-2xl border border-slate-800 bg-slate-900/60 p-5">
    <div className="flex items-start gap-2">
      <div className="flex-1">
        <p className="font-semibold">{o.nombre}</p>
        <p className="text-xs text-slate-500">{o.tipo === 'ordinario' ? 'Tribunal ordinario' : 'Tribunal especial'} · nivel {o.jerarquia}</p>
      </div>
      {admin && <CatalogEdit kind="organo" item={o} field="competencia" onDone={onChange} />}
    </div>
    <p className="mt-2 text-sm text-slate-300">{o.competencia}</p>
    <div className="mt-3 grid gap-4 md:grid-cols-3">
      <div className="flex flex-col gap-2"><p className="text-[11px] uppercase tracking-wide text-slate-500">Base legal</p>{o.base.map((b) => <LegalRef key={b.key + b.art} r={b} />)}</div>
      <div className="flex flex-col gap-2"><p className="text-[11px] uppercase tracking-wide text-slate-500">Procedimientos</p>
        {o.procedimientos.length ? o.procedimientos.map((p) => <div key={p.nombre}><p className="text-xs font-medium text-slate-300">{p.nombre}</p><LegalRef r={p.base} /></div>) : <p className="text-xs text-slate-500">Según su ley especial (ver base legal)</p>}</div>
      <div className="flex flex-col gap-2"><p className="text-[11px] uppercase tracking-wide text-slate-500">Recursos</p>
        {o.recursos.length ? o.recursos.map((r) => <div key={r.nombre}><p className="text-xs font-medium text-slate-300">{r.nombre} · {r.plazo}</p><LegalRef r={r.base} /></div>) : <p className="text-xs text-slate-500">No catalogados aún: revisa la ley especial</p>}</div>
    </div>
    {!!o.correcciones?.length && <p className="mt-3 text-[11px] text-amber-300/80">Corregido por {o.correcciones.map((c) => `${c.by} (${c.at.slice(0, 10)}${c.note ? `: ${c.note}` : ''})`).join(' · ')}</p>}
  </div>
);

export const AreaRow = ({ a, admin, onChange }) => (
  <div data-testid={`area-${a.id}`} className="rounded-xl border border-slate-800 bg-slate-900/40 p-4">
    <div className="flex items-start gap-2">
      <p className="flex-1 font-semibold">{a.nombre}</p>
      {admin && <CatalogEdit kind="area" item={a} field="nota" onDone={onChange} />}
    </div>
    {a.nota && <p className="text-xs text-slate-300">{a.nota}</p>}
    <div className="mt-2 grid gap-3 md:grid-cols-2">
      <div className="flex flex-col gap-1.5">{a.normas.map((n) => <LegalRef key={n.key + n.art} r={n} />)}</div>
      <p className="text-xs text-slate-400">Órganos competentes: {a.organos.map((o) => o.nombre).join(' · ')}</p>
    </div>
  </div>
);
